import { Alert } from "@mui/material";
import { ErrorDetailContainer } from "../../api/config";

export default function ErrorParser(props: { error: ErrorDetailContainer }) {
    const errors = props.error?.errors;

    if (errors) {
        return (
            <>
                {errors.map((e) => {
                    return (
                        <Alert severity="error" key={e.code}>
                            {e.message}
                        </Alert>
                    );
                })}
            </>
        );
    }

    return <></>;
}
